import React from "react";

const items = [
  "Resume",
  "Education",
  "Key Skills",
  "Experience",
  "Projects",
  "Internships",
  "Preferences",
  "Languages",
  "Certifications & Achievements",
];

export default function Sidebar({ sections = items, onSelect }) {
  return (
    <aside className="sidebar">
      <div className="sidebar-card">
        <h3>Quick links</h3>
        <ul>
          {sections.map((s) => (
            <li key={s} onClick={() => onSelect(s)}>{s}</li>
          ))}
        </ul>
      </div>
    </aside>
  );
}
